import {Component, inject, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {QuoteService} from '../../../services/quote.service';

@Component({
  selector: 'app-quote-attachments-details',
  templateUrl: './quote-attachments-details.component.html',
  standalone: false
})
export class QuoteAttachmentsDetailsComponent implements OnInit {
  paginatedImages: any[] = [];
  totalItems: number = 0;
  quoteId: any;
  page: number = 1;
  itemsPerPage: number = 10;
  totalPages: number = 1;
  showLoading: boolean = false;
  offset: number = 0;

  protected readonly String = String;
  protected readonly Math = Math;
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly quoteService = inject(QuoteService);

  ngOnInit() {
    this.quoteId = this.route.snapshot.queryParams['quote_id'];
    this.getQuoteAttachmentsWithPagination(this.quoteId, this.itemsPerPage, this.offset);
  }

  getQuoteAttachmentsWithPagination(quote_id: string, limit: number, offset: number) {
    this.quoteService.getQuoteAttachments(quote_id, limit, offset).then((data: any) => {
      if (!data) {
        return;
      }
      if (data.Data || data.Data.length > 0) {
        this.totalItems = data.Data[0].total_count;
        this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        this.paginatedImages = data.Data;
      }
    }).catch(() => {
      return;
    });
  }

  nextPage() {
    if (this.page < this.totalPages) {
      this.page++;
      this.offset = this.offset + 10;
      this.getQuoteAttachmentsWithPagination(this.quoteId, this.itemsPerPage, this.offset);
    }
  }

  prevPage() {
    if (this.page > 1) {
      this.page--;
      this.offset = this.offset - 10;
      this.getQuoteAttachmentsWithPagination(this.quoteId, this.itemsPerPage, this.offset);
    }
  }

  goToQuotePage() {
    this.router.navigate(['/quote'], {queryParams: {quote_id: this.quoteId}}).toString();
  }
}
